import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyCB2xD7iZqZ4rZApT7dn3waNBSGKrrTJV8',
  authDomain: 'clotho-ciesse.firebaseapp.com',
  projectId: 'clotho-ciesse',
  storageBucket: 'clotho-ciesse.firebasestorage.app',
  messagingSenderId: '1042449669300',
  appId: '1:1042449669300:web:a4dbd91e8b08dc99ca4be1',
};

export const firebaseApp = initializeApp(firebaseConfig);

export async function getFirebaseMessaging() {
  const supported = await isSupported();

  if (!supported) {
    return null;
  }

  return getMessaging(firebaseApp);
}